import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { LoadingWLogo } from './components/LoadingWLogo';
import Logout from './pages/Logout';
import { PostData, PostDataPromise } from './components/Functions/SendingData';
import StakcableError from './components/StakcableError';
import UniBasket from './components/Menu/UniBasket';
import NavBar from './components/NavBar';
import Footer from './components/Footer';
import PageTitles from './components/Functions/PageTitles';
import ModalLogin from './components/User/ModalLogin';
import ErrorBoundary from './pages/ErrorBoundary';
import Application from './pages/Application';
import Profiles from './pages/Profiles';
// import DisplayError from './pages/DisplayError';
// import NewSeller from './pages/NewSeller';
// import NavBarHome2 from './components/NavbarHomeV2Main';

// import CategoriesPageNew from './pages/CategoriesPageNew';
// import CategoryPageApp from './pages/CategoryPageApp';
// import Home from './pages/Home';
// import Search from './pages/Search';
// import Goods from './pages/Goods';

// import IsLogin from './components/IsLogin';

// import GoodPage from './pages/GoodPage';
// import User from './pages/User';
// import Shops from './pages/Shops';

// import Affiliate from './pages/Affiliate';
// import ShopPage from './pages/ShopPage';
// import GoodShopPage from './pages/GoodShopPage';


// import ProfileOrder from './pages/User/ProfileOrder';
// import ContactUs from './pages/ContactUs';
// import AboutUs from './pages/AboutUs';
// import CustomOrder from './pages/CustomOrder';
// import BuyingProcess from './pages/StackedForms/BuyingProcess';
// import UserAfiliate from './pages/UserAfiliate';
// import GoodCommentForm from './components/HomeComp/GoodCommentForm';
// import Send from './pages/Send';
// import BasketCode from './pages/Send/BasketCode';
// import CategoriesPage from './pages/CategoriesPage';
// import CategoryPage from './pages/CategoryPage';

// import GoodPage2 from './pages/GoodPageV2Main';
// import GoodsV2 from './pages/GoodsV2';
// import Brands from './pages/Brands';
// import CategoryPageNew from './pages/CategoryPageNew';
// import LastCategoriesPage from './pages/LastCategoriesPage';
// import BrandPage from './pages/BrandPage';
// import Campaign from './pages/Campaign';
// import NewSeller2 from './pages/NewSeller2';
// import NoMatch from './pages/NoMatch';

const Home = lazy(() => import('./pages/Home'));
const Home2 = lazy(() => import('./pages/Home2'));

// const Search = lazy(() => import('./pages/Search'));
const Goods = lazy(() => import('./pages/Goods'));
const IsLogin = lazy(() => import('./components/IsLogin'));
// const NoMatch = lazy(() => import('./pages/NoMatch'));

// const GoodPage = lazy(() => import('./pages/GoodPage'));
const User = lazy(() => import('./pages/User'));
const Shops = lazy(() => import('./pages/Shops'));
// const Affiliate = lazy(() => import('./pages/Affiliate'));
const ShopPage = lazy(() => import('./pages/ShopPage'));
const GoodShopPage = lazy(() => import('./pages/GoodShopPage'));

const ProfileOrder = lazy(() => import('./pages/User/ProfileOrder'));
const Test = lazy(() => import('./pages/Test'));
const ContactUs = lazy(() => import('./pages/ContactUs'));
const AboutUs = lazy(() => import('./pages/AboutUs'));
const CustomOrder = lazy(() => import('./pages/CustomOrder'));
const BuyingProcess = lazy(() => import('./pages/StackedForms/BuyingProcess'));
const UserAfiliate = lazy(() => import('./pages/UserAfiliate'));

// const GoodCommentForm = lazy(() => import('./components/HomeComp/GoodCommentForm'));
const Send = lazy(() => import('./pages/Send'));
const BasketCode = lazy(() => import('./pages/Send/BasketCode'));
// const CategoriesPageNew = lazy(() => import('./pages/CategoriesPageNew'));
// const CategoryPage = lazy(() => import('./pages/CategoryPage'));
const FAQ = lazy(()=> import('./pages/FAQ'))
const Rules = lazy(()=> import('./pages/Rules'))

const GoodPage2 = lazy(()=> import('./pages/GoodPageV2Main'))
const GoodsV2 = lazy(()=> import('./pages/GoodsV2'));
const Brands = lazy(()=> import('./pages/Brands'));
const CategoryPageNew = lazy(()=> import('./pages/CategoryPageNew'));
const LastCategoriesPage = lazy(()=> import('./pages/LastCategoriesPage'));
const BrandPage = lazy(()=> import('./pages/BrandPage'));
const Campaign = lazy(()=> import('./pages/Campaign'));
const NewSeller2 = lazy(()=> import('./pages/NewSeller2'));
const NoMatch = lazy(()=> import('./pages/NoMatch'));


export const Addvert = false;

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userdata: false,
      cart: [],
      notif:'',
      basketInit: true,
      smallLoading: true,
      sending: false,
      basket: [],
      back_cart: [],
      basket_sum: '0',
      showFilter:false,
      open:false,
      gift_discount: 0,
      pocket:{}
    };
  }
  UpdateUserdata() {
    this.getUserData();
    this.getBasketData();
  }
  isLoginOut() {
    this.isLogin();
    this.getUserData();
    this.getBasketData();
  }
  // main initial get datas and bining
  componentDidMount() {
    UpdateUserdata = this.UpdateUserdata.bind(this);
    isLoginOut = this.isLoginOut.bind(this);
    this.isLogin();
    this.getBasketData();
    this.getUserData();
  }

  // proccess user data and cache
  Proccess(obj, response) {
    response = JSON.parse(response);
    
    if (response.status === 'success') {
      obj.setState({
        sending: false,
        userdata: response.data,
        notif:response.new_notif_count,
        pod_create_verify : response.pod_create_verify,
        pocket:{
          pod: response.pod_walet,
          lxn : response.hbg_walet
        }
      });
      localStorage.setItem('userdata', JSON.stringify(response.data));
    } else if (response.status === 'error') {
      obj.setState({
        sending: false,
        userdata: false,
      });
    } else if (response.status === 'error-no-internet') {
      obj.setState({
        sending: false,
        userdata: false,
      });
    }
  }
  setOpen = (e) => {
    this.setState({
        open: e
    })
  }
  // function for getting user data
  getUserData = () => {
    let formData = new FormData();
    formData.append('api_token', localStorage.getItem('token'));
    if(localStorage.getItem('token')){
      PostData(
        process.env.REACT_APP_API + '/api/v1/userprofile/info',
        formData,
        this,
        this.Proccess
      );
    }else{
      return ''
    }
  };

  // see if user is logined and update cache data
  isLogin() {
    let token = localStorage.getItem('token');
    if (token !== null) {
      this.setState({
        userdata: JSON.parse(localStorage.getItem('userdata')),
      });
    }else {
      this.setState({
        userdata: false,
      });
    }
  }
  visibleFilter=()=>{
    this.setState({
      showFilter : !this.state.showFilter
    })
  }
  // render main routing system and nav bar and universal componnents
  render() {
    return (
      <React.Fragment>
        <ErrorBoundary>
        <Router>
            <PageTitles/>
            <Route
              path="/"
              render={(props) => (
                <NavBar
                  {...props}
                  userdata={this.state.userdata}
                  loading={this.state.basketInit}
                  cart={this.state.back_cart}
                  notif={this.state.notif}
                  visibleFilter={this.visibleFilter}
                  showFilter={this.state.showFilter}
                  setOpen={this.setOpen}
                  open={this.state.open}
                />
              )}
            />
            {/* <Route
              path="/"
              render={(props) => (
                <NavBarHome2
                  {...props}
                  userdata={this.state.userdata}
                  loading={this.state.basketInit}
                  cart={this.state.back_cart}
                  notif={this.state.notif}
                  visibleFilter={this.visibleFilter}
                  showFilter={this.state.showFilter}
                  setOpen={this.setOpen}
                  open={this.state.open}
                />
              )}
            /> */}
            {/* login modal */}
            <ModalLogin open={this.state.open} setOpen={this.setOpen} name='user'/>
            <Suspense fallback={<LoadingWLogo/>}>
                <Switch>
                  <Route
                    exact
                    path="/"
                    render={(props) => (
                      <Home2
                        {...props}
                        userdata={this.state.userdata}
                        loading={this.state.basketInit}
                        cart={this.state.back_cart}
                        notif={this.state.notif}
                        setOpen={this.setOpen}
                        open={this.state.open}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/home1"
                    render={(props) => (
                      <Home
                        {...props}
                        userdata={this.state.userdata}
                        loading={this.state.basketInit}
                        cart={this.state.back_cart}
                        notif={this.state.notif}
                        setOpen={this.setOpen}
                        open={this.state.open}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/test"
                    render={(props) => <Test {...props} />}
                  />
                  <Route
                    exact
                    path="/contactus"
                    render={(props) => <ContactUs {...props} />}
                  />
                  <Route
                    exact
                    path="/aboutus"
                    render={(props) => <AboutUs {...props} />}
                  />
                  <Route
                    exact
                    path="/application"
                    render={(props) => <Application {...props} />}
                  />
                  {/* <Route
                    exact
                    path="/search"
                    render={(props) => (
                      <Search {...props} userdata={this.state.userdata} />
                    )}
                  /> */}
                  <Route
                    exact
                    path="/brands"
                    render={(props) => (
                      <Brands {...props} userdata={this.state.userdata} />
                    )}
                  />
                  <Route
                    exact
                    path="/brand/:br_name"
                    render={(props) => (
                      <BrandPage {...props} userdata={this.state.userdata} />
                    )}
                  />
                  {/* <Route
                    exact
                    path="/brand/:br_code"
                    render={(props) => ( ///brand page
                      <ShopPage {...props} userdata={this.state.userdata} showFilter={this.state.showFilter}/>
                    )}
                  /> */}
                  <Route
                    exact
                    path="/shops"
                    render={(props) => (
                      <Shops {...props} userdata={this.state.userdata} />
                    )}
                  />
                  <Route
                    exact
                    path="/shops/:gr"
                    render={(props) => (
                      <Shops {...props} userdata={this.state.userdata} />
                    )}
                  />
                  <Route
                    exact
                    path="/shop/:sh_code"
                    render={(props) => (
                      <ShopPage {...props} userdata={this.state.userdata} showFilter={this.state.showFilter}/>
                    )}
                  />
                  <Route
                    exact
                    path="/shop/:sh_code/:gr"
                    render={(props) => (
                      <ShopPage {...props} userdata={this.state.userdata} showFilter={this.state.showFilter} />
                    )}
                  />
                  {/* <Route
                    exact
                    path="/shop/:sh_code/:order/:gr"
                    render={(props) => (
                      <ShopPage {...props} userdata={this.state.userdata} />
                    )}
                  /> */}
                  {/* <Route
                    exact
                    path="/shop/:sh_code/:order/:gr/:subgr"
                    render={(props) => (
                      <ShopPage {...props} userdata={this.state.userdata} />
                    )}
                  />
                  <Route
                    exact
                    path="/shop/:sh_code/:order/:gr/:subgr/:brand"
                    render={(props) => (
                      <ShopPage {...props} userdata={this.state.userdata} />
                    )}
                  /> */} 
                  <Route
                    exact
                    path="/categories"
                    render={(props) => (
                      <LastCategoriesPage {...props} userdata={this.state.userdata} />
                    )}
                  />
                  {/* <Route
                    exact
                    path="/category/:catID/"
                    render={(props) => (
                      <CategoryPage {...props} userdata={this.state.userdata} showFilter={this.state.showFilter}/>
                    )}
                  /> */}
                  <Route
                    exact
                    path="/category/:catID"
                    render={(props) => (
                      <CategoryPageNew {...props} userdata={this.state.userdata} showFilter={this.state.showFilter}/>
                    )}
                  />
                  <Route
                    exact
                    path="/search2"
                    render={(props) => (
                      <Goods {...props} userdata={this.state.userdata} showFilter={this.state.showFilter}/>
                    )}
                  />
                  <Route
                    exact
                    path="/search"
                    render={(props) => (
                      <GoodsV2 {...props} userdata={this.state.userdata} showFilter={this.state.showFilter}/>
                    )}
                  />
                  {/* <Route
                    exact
                    path="/search/:order/"
                    render={(props) => (
                      <Goods {...props} userdata={this.state.userdata} showFilter={this.state.showFilter}/>
                    )}
                  /> */}
                  <Route
                    exact
                    path="/search2/:gr/"
                    render={(props) => (
                      <Goods {...props} userdata={this.state.userdata} showFilter={this.state.showFilter}/>
                    )}
                  />
                  <Route
                    exact
                    path="/search/:gr/"
                    render={(props) => (
                      <GoodsV2 {...props} userdata={this.state.userdata} showFilter={this.state.showFilter}/>
                    )}
                  />
                  {/* <Route
                    exact
                    path="/search/:order/:gr/:subgr"
                    render={(props) => (
                      <Goods {...props} userdata={this.state.userdata} />
                    )}
                  /> */}
                  {/* <Route
                    exact
                    path="/good/:g_code"
                    render={(props) => (
                      <GoodPage {...props} userdata={this.state.userdata} />
                    )}
                  /> */}
                  {/* <Route
                    exact
                    path="/good/:g_code/:sh_code"
                    render={(props) => ( 
                    <GoodPage {...props} userdata={this.state.userdata} setOpen={this.setOpen} open={this.state.open} />
                    )}
                  /> */}
                  <Route
                    exact
                    path="/good/:g_code/:sh_code"
                    render={(props) => ( 
                    <GoodPage2 {...props} userdata={this.state.userdata} setOpen={this.setOpen} open={this.state.open} />
                    )}
                  />
                  <Route
                    exact
                    path="/good/:g_code/:sh_code/:shop"
                    render={(props) => ( 
                    <GoodPage2 {...props} userdata={this.state.userdata} setOpen={this.setOpen} open={this.state.open} />
                    )}
                  />
                  {/* <Route
                    exact
                    path="/good/:g_code/:sh_code/comment"
                    render={(props) => (
                      <GoodCommentForm {...props} userdata={this.state.userdata} />
                    )}
                  /> */}
                  <Route
                    exact
                    path="/shopgood/:sh_g_code"
                    render={(props) => (
                      <GoodShopPage {...props} userdata={this.state.userdata} />
                      )}
                  />
                  <Route
                    exact
                    path="/profile"
                    render={(props) => (
                      <User {...props} userdata={this.state.userdata}  notif={this.state.notif}  getUserData={this.getUserData} pod_create_verify={this.state.pod_create_verify} />
                    )}
                  />
                  <Route
                    path="/profile/:u_code"
                    render={(props) => (
                      <User {...props} userdata={this.state.userdata} notif={this.state.notif} getUserData={this.getUserData} setOpen={this.setOpen}  pod_create_verify={this.state.pod_create_verify}/>
                    )}
                  />
                  {/* <Route path="/basket" render={props => (<ProfileBasket {...props} userdata={this.state.userdata} loading={this.state.basketInit} smallLoading={this.state.smallLoading} cart={this.state.back_cart} basket_sum={this.state.basket_sum} func={this.getBasketData} load={this.makeSmallItLoad}/>)}/>
                    <Route path="/checkout" render={props => (<ProfileCheckout {...props} userdata={this.state.userdata}  loading={this.state.basketInit} cart={this.state.back_cart} basket_sum={this.state.basket_sum} func={this.getBasketData}/>)}/>
                    <Route path="/payment" render={props => (<ProfilePayment {...props} userdata={this.state.userdata}  loading={this.state.basketInit} cart={this.state.back_cart} basket_sum={this.state.basket_sum} func={this.getBasketData}/>)}/> */}
                  <Route
                    exact
                    path="/buying/:stage"
                    render={(props) => (
                      <BuyingProcess
                        {...props}
                        userdata={this.state.userdata}
                        loading={this.state.basketInit}
                        smallLoading={this.state.smallLoading}
                        cart={this.state.back_cart}
                        basket_sum={this.state.basket_sum}
                        basket_tax= {this.state.basket_tax}
                        basket_tool= {this.state.basket_tool}
                        basket_total= {this.state.basket_total}
                        total_transport_cost={this.state.total_transport_cost}
                        basket_discount={this.state.basket_discount}
                        gift_discount={this.state.gift_discount}
                        func={this.getBasketData}
                        load={this.makeSmallItLoad}
                        setOpen={this.setOpen}
                        open={this.state.open}
                        pocket={this.state.pocket}
                      />
                    )}
                  />
                  <Route
                    path="/buying/:stage/:INO"
                    render={(props) => (
                      <BuyingProcess
                        {...props}
                        userdata={this.state.userdata}
                        loading={this.state.basketInit}
                        smallLoading={this.state.smallLoading}
                        cart={this.state.back_cart}
                        basket_sum={this.state.basket_sum}
                        func={this.getBasketData}
                        pocket={this.state.pocket}
                        load={this.makeSmallItLoad}
                        setOpen={this.setOpen}
                      />
                    )}
                  />
                  
                  <Route
                    path="/order/:is_okay"
                    render={(props) => (
                      <ProfileOrder {...props} userdata={this.state.userdata} setOpen={this.setOpen} open={this.state.open}/>
                    )}
                  />
                  <Route path="/user" render={(props) => <IsLogin {...props} name='user'/>} />
                  <Route path="/logout" component={Logout} />
                  {/* <Route
                    path="/affiliate"
                    render={(props) => (
                      <Affiliate {...props} userdata={this.state.userdata} />
                    )}
                  /> */}
                  <Route
                    exact
                    path="/custom-order"
                    render={(props) => (
                      <CustomOrder {...props} userdata={this.state.userdata} />
                    )}
                  />
                  <Route
                    path="/custom-order/:order_step"
                    render={(props) => (
                      <CustomOrder {...props} userdata={this.state.userdata} />
                    )}
                  />
                  <Route
                    path="/code/:id_code"
                    render={(props) => (
                      <UserAfiliate {...props} userdata={this.state.userdata} />
                    )}
                  />
                  <Route
                    exact
                    path="/send"
                    render={(props) => (
                      <Send {...props} userdata={this.state.userdata} />
                    )}
                  />
                  <Route
                    exact
                    path="/send/:id/"
                    render={(props) => (
                      <BasketCode {...props} userdata={this.state.userdata} />
                    )}
                  />
                  <Route
                    exact
                    path="/send/:id/:code"
                    render={(props) => (
                      <BasketCode {...props} userdata={this.state.userdata} />
                    )}
                  />
                  {/* <Route
                    exact
                    path="/blog"
                    render={(props) => (
                      <Blog {...props} userdata={this.state.userdata} />
                    )}
                  /> */}
                  <Route
                    exact
                    path="/rules"
                    render={(props) => (
                      <Rules {...props} userdata={this.state.userdata} />
                    )}
                  />
                  <Route
                    exact
                    path="/questions"
                    render={(props) => (
                      <FAQ {...props} userdata={this.state.userdata} />
                      )}
                  />
                  <Route
                    exact
                    path="/singup-seller"
                    render={(props) => (
                      <NewSeller2 {...props} userdata={this.state.userdata} />
                    )}
                  />
                  <Route
                    exact
                    path="/campaign/:name"
                    render={(props) => (
                      <Campaign {...props} userdata={this.state.userdata} />
                    )}
                  />

                  {/* <Route path="/error" component={Errors} /> */}

                  {/* <Route
                    exact
                    path="/errorrpagesss"
                    render={(props) => (
                      <DisplayError {...props} userdata={this.state.userdata} />
                    )}
                  /> */}
                  <Route
                    exact
                    path="/personel"
                    render={(props) => (
                      <Profiles {...props} userdata={this.state.userdata} />
                    )}
                  />
                  <Route
                    exact
                    path="/personel/:id"
                    render={(props) => (
                      <Profiles {...props} userdata={this.state.userdata} />
                    )}
                  />
                  <Route component={NoMatch} />
                </Switch>
                <Route
                  path="/"
                  render={(props) => (
                    <Footer {...props} userdata={this.state.userdata} />
                  )}
                />
              </Suspense>            
            <Route
              path="/"
              render={(props) => (
                <UniBasket
                  {...props}
                  userdata={this.state.userdata}
                  loading={this.state.basketInit}
                  cart={this.state.back_cart}
                  basket_sum={this.state.basket_sum}
                  func={this.getBasketData}
                  load={this.makeItLoad}
                  notif={this.state.notif}
                  setOpen={this.setOpen}
                  open={this.state.open}
                />
              )}
            />
            <StakcableError />
        </Router>
        </ErrorBoundary>
      </React.Fragment>
    );
  }

  
  //basket functions
  // change main load state
  makeItLoad = () => {
    this.setState({
      basketInit: false,
    });
  };

  // chnage small change operator 
  makeSmallItLoad = () => {
    this.setState({
      smallLoading: false,
    });
  };

  // update main basket data
  getBasketData = async (loading = 'big') => {
    let formData = new FormData();
    formData.append('api_token', localStorage.getItem('token'));
    if( localStorage.getItem('token')){
      // if offline basket add to server and delete offline
      let items = [];
      if(localStorage.getItem("luxinlux-basket")) {
        items = JSON.parse(localStorage.getItem("luxinlux-basket"));
      }
      if(items.length){
        items = items.map((v) => {
          return {
            SH_G_CODE: v.SH_G_CODE,
            COUNT: v.TEMP_BASK_COUNT,
          }
        });
        let formData2 = new FormData();
        formData2.append('DATA', JSON.stringify(items));
        formData2.append('api_token', localStorage.getItem('token'));
        let res = await PostDataPromise(process.env.REACT_APP_API + "/api/v1/basket/Bask_Detail/group_insert", formData2);
        let response = JSON.parse(res);
        if (response.status === 'success') {
          localStorage.removeItem("luxinlux-basket")
        }
      }
      if (loading === 'small') {
        this.setState({
          smallLoading: false,
        });
      } else {
        this.setState({
          basketInit: false,
        });
      }
      PostData(
        process.env.REACT_APP_API + '/api/v1/goods/g_basket/basket',
        formData,
        this,
        this.ProccessBasket
      );
    }else{
      // offline basket
      let items = [];
      if(localStorage.getItem("luxinlux-basket")) {
        items = JSON.parse(localStorage.getItem("luxinlux-basket"));
      }
      // get items from web
      items = items.map((v) => {
        return {
          SH_G_CODE: v.SH_G_CODE,
          COUNT: v.TEMP_BASK_COUNT,
        }
      });
      let formData = new FormData();
      formData.append('DATA', JSON.stringify(items));
      let res = await PostDataPromise(process.env.REACT_APP_API + "/api/v1/exb/local_temp_basket", formData);
      let response = JSON.parse(res);
      if (response.status === 'success') {
        let basketsum = 0
        let baskettool = 0
        let baskettax = 0
        let baskettotal = 0;
        let totalamount = 0;
        let datamain = response.data;
        if(!Array.isArray(datamain)){
          datamain = [datamain]
        }
        for (let i = 0; i < response.data.length; i++) {
          const item2 = response.data[i];
          for (let j = 0; j < item2.SHOP_BASKET.length; j++) {
            const item = item2.SHOP_BASKET[j];
            basketsum = basketsum + item.TEMP_BASK_SUM;
            baskettool = basketsum + item.TEMP_BASK_TOLL;
            baskettax = basketsum + item.TEMP_BASK_TAX;
            baskettotal = baskettotal + item.TEMP_BASK_TOTAL;
            totalamount = totalamount + item.TEMP_BASK_COUNT;
          }
        }
        this.setState({
          basketInit: true,
          smallLoading: true,
          sending: false,
          back_cart: datamain,
          basket_sum: basketsum,
          basket_tax: baskettax,
          basket_tool: baskettool,
          basket_total: baskettotal,
          total_transport_cost: '0',
          basket_discount: '0'
        });
      } else if (response.status === 'error') {
        this.setState({
          basketInit: true,
          smallLoading: true,
          sending: false,
          basket: [],
          back_cart: [],
          basket_sum: '0',
        });
      } else {
        this.setState({
          basketInit: true,
          smallLoading: true,
          sending: false,
          basket: [],
          back_cart: [],
          basket_sum: '0',
        });
      }
      // set states
      return
    }
    
  };

  // proccess basket data
  ProccessBasket(obj, response) {
    response = JSON.parse(response);

    if (response.status === 'success') {
      obj.setState({
        basketInit: true,
        smallLoading: true,
        sending: false,
        back_cart: response.data_detail_basket,
        basket_sum: response.basket_sum,
        basket_tax: response.basket_tax,
        basket_tool: response.basket_tool,
        basket_total: response.basket_total,
        total_transport_cost:response.total_transport_cost,
        basket_discount:response.basket_discount,
        gift_discount: response.gift_discount,
        
      });
      // localStorage.setItem('userdata', JSON.stringify(response.data));
    } else if (response.status === 'error') {
      obj.setState({
        basketInit: true,
        smallLoading: true,
        sending: false,
        basket: [],
        back_cart: [],
        basket_sum: '0',
      });
    } else if (response.status === 'error-no-internet') {
      obj.setState({
        basketInit: true,
        smallLoading: true,
        sending: false,
        basket: [],
        back_cart: [],
        basket_sum: '0',
      });
    }
  }
}
// binding update user data to main object
export var UpdateUserdata;
// export function UpdateUserdata() {
//   this.getUserData();
//   this.getBasketData();
// }

// biding for login update and log out functions
export var isLoginOut;
// export function isLoginOut() {
//   this.isLogin();
//   this.getBasketData();
// }

export default App;



